import { PeriodicElement } from './../vergastos.component';
import { AdminGuardService } from '../../../servicios/guards/admin-guard.service';
import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, DoCheck } from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog} from '@angular/material';

import {SelectionModel} from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";

import { AuthService } from '../../../servicios/auth.service';
import { UserGuardService } from '../../../servicios/guards/user-guard.service';
import { MultiUserGuardService } from '../../../servicios/guards/multi-user.service';

import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import { environment } from "environments/environment";
import { Router } from '@angular/router';

//ngx-webcam 1
import {Subject} from 'rxjs';
import {Observable} from 'rxjs';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import { GLOBALService } from "../../../servicios/functions/GLOBAL.service";


export interface PeriodicElement {
  COD_DETALLE:string;
  FECHA_CARGA: string;
  FECHA_TICKET: string;
  DETALLE: string;
  IMPORTE: string;
  CATEGORIA: string;
  OBSERVACIONES: string;
  IMAGEN: string;
}
//cod_gasto: this.codgas, fecha_hoy: moment(this.fecha_hoy).format('YYYY-MM-DD'), 
//fecha_ticket: moment(this.FECHA_TICKET).format('YYYY-MM-DD'),  detalle: this.DETALLE, 
//importe: this.IMPORTE, categoria: this.CATEGORIA, imagen: this.fotodetalle
export interface PeriodicElement2 {
  cod_gasto:string;
  fecha_hoy: string;
  fecha_ticket: string;
  detalle: string;
  importe: string;
  categoria: string;
  observaciones:string;
  imagen: string;
}
var ELEMENT_DATA: PeriodicElement[] = [];
var ELEMENT_DATA4: PeriodicElement2[] = [];

@Component({
  selector: 'app-verdetalles',
  templateUrl: './verdetalles.component.html',
  styleUrls: ['./verdetalles.component.css']
})


export class VerdetallesComponent implements OnInit, DoCheck {
  //ngx-webcam 2
  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };
  public errors: WebcamInitError[] = [];

  // latest snapshot
  public webcamImage: WebcamImage = null;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();


  COD_DETALLE:string;
  FECHA_CARGA = new   Date;
  fecha_hoy: string;
  FECHA_TICKET: string;
  DETALLE: string;
  IMPORTE: string;
  CATEGORIA: string;
  OBSERVACIONES: string;
  IMAGEN: string;
  
  result;
  
    public uploader: FileUploader = new FileUploader({
    url: `${environment.backendUrl}/api/importador/importar`,
    itemAlias: 'foto',
    headers: [{ name: 'Access-Control-Allow-Origin', value: '*'}]
  });

  booleano=false;
  ngDoCheck(){
    console.log(this.DETALLE);  
  }

  getFiles(event) {
    this.files = event.target.files;
    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(this.files[0]); 
  }
   //obtengo base64 de imagen subida
   _handleReaderLoaded(readerEvt) {
    var b64String = readerEvt.target.result;
    this.fotob64=b64String
    //console.log(this.fotob64);
  }




  @ViewChild('TABLE') table: ElementRef;
  codgas;
  displayedColumns: string[] = ['select','COD_DETALLE', 'FECHA_CARGA', 'FECHA_TICKET', 'DETALLE', 'IMPORTE', 'CATEGORIA', 'OBSERVACIONES', 'IMAGEN'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  selection = new SelectionModel<PeriodicElement>(true, []);
  dateValue: any; //para fecha calendar
  selectedDate;//para fecha calendar
  codi_detalle_edit: number;
  det_edit;
  imp_edit;
  fec_edit;
  tot_gasto;
  detalleGasto;
  fotito;
  loading;
  fotodetalle;
  estadoGasto;

  //para subir foto
  files;
  fotob64;
  obs;
  detallito:FormGroup;

  constructor(
              private http: HttpClient,
              public dialog: MatDialog,
              private datePipe: DatePipe,
              //snackbar 2
              public snackBar: MatSnackBar,
              private router: Router,
              private global: GLOBALService
  ){ 
    this.loading=true;
  }

  transformDate(date) {
    this.datePipe.transform(this.FECHA_CARGA, 'yyyy-MM-dd'); //whatever format you need. 
  }

  selectRow(row, det, imp, fec, img, obs) {
    this.codi_detalle_edit=row;
    this.det_edit = det;
    this.imp_edit = imp;
    this.fec_edit = fec;
    this.fotito = img;
    this.obs = obs;
    
    console.log(this.codi_detalle_edit);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Si el número de elementos seleccionados coincide con el número total de filas..
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

    //Selecciona todas las filas si no están todas seleccionadas; de lo contrario, borra la seleccion
    masterToggle() {
      this.isAllSelected() ?
          this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));
    }
    
    addEvent(input: string, $event) {
      this.selectedDate = moment($event.value).format('YY-MM-DD');
      this.FECHA_TICKET = this.selectedDate;
      moment(this.FECHA_TICKET).format('YYYY-MM-DD');
      console.log("FECHA DEL TICKET NUEVO:" + this.FECHA_TICKET);
    }

  role;
  ngOnInit() {
    window.scroll(0,0);
    //lleno categorias
    this.role=localStorage.getItem('role');

    this.llenarCategorias();

    
    ////ngx-webcam 3
    WebcamUtil.getAvailableVideoInputs()
    .then((mediaDevices: MediaDeviceInfo[]) => {
      this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
    });
    //
    this.estadoGasto = localStorage.getItem('estadoGasto');
    localStorage.removeItem('arrayGastoPrint');
    this.detalleGasto = localStorage.getItem('detalleGasto');
    this.tot_gasto = localStorage.getItem("imp_gasto");
    this.fecha_hoy = this.datePipe.transform(this.FECHA_CARGA,"yyyy-MM-dd");
    console.log(this.fecha_hoy);
    
    console.log(this.datePipe.transform(this.FECHA_CARGA,"yyyy-MM-dd"));
    this.codgas=localStorage.getItem('codgasto_edit');
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    setTimeout(() => {
      console.log("cargando grid..");
      this.cargaGrid();
    }, 1000);

  }

  idsec;
  dataSourceCategorias;
  
  llenarCategorias(){
    //http://localhost:1337/api/llenarcategorias/ver?rol=PAGADOR
    this.http.get(`${environment.backendUrl}/api/llenarcategorias/ver?rol=${this.role}`)
    .subscribe((data: any[]) => {
      this.dataSourceCategorias=data;
      console.log(this.dataSourceCategorias); 
    });

  }

  //ngx-webcam 3
  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean|string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.info('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
    //console.log(this.webcamImage.imageAsDataUrl);
    //hago el resize de la fotodetalle antes de guardarlo
    console.log("resize imagen desde webcam..");
    this.fotodetalle=this.webcamImage.imageAsDataUrl;
  }

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }

  limpiacam(){
    this.showWebcam = false;
    this.fotodetalle=[];
    this.fotodetalle=null;
    
    this.webcamImage=null;
  }

  // fin ngx-webcam 



  ngAfterViewInit() {    
    
  }


  cargaGrid(){
    this.http.get(`${environment.backendUrl}/api/vergastos/detalle?codgas=${this.codgas}&ima=SI`)
    .subscribe((data: any[]) => {
      this.dataSource.data = data; 
      this.loading=false; 
    });
    console.log("grid cargado..");
  }

  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);//converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `Gastos-${localStorage.getItem('apellidonombre')}_viaje.xlsx`);
  }

  enviarCodDetalle(){
    //al hacer click en editar en el modal, envio al local storage el codigo de gasto a editar
    localStorage.setItem('coddetalle_edit', `${this.codi_detalle_edit}`);  
    console.log(localStorage.getItem('coddetalle_edit'));
  }

  volver(){
    localStorage.removeItem('codgasto_edit');
    this.codgas = null;
    console.log("borro el codgasto to_edit");
  }


  insertarNuevo(){
    let data = { 
      cod_gasto: this.codgas,
      fecha_hoy: moment(this.fecha_hoy).format('YYYY-MM-DD'),
      fecha_ticket: moment(this.FECHA_TICKET).format('YYYY-MM-DD'),
      detalle: this.DETALLE,
      importe: this.IMPORTE,
      categoria: this.CATEGORIA,
      observaciones: this.OBSERVACIONES,
      imagen: this.fotodetalle
    };
    ELEMENT_DATA4.push(data);
    console.log("asi queda el registro");
    console.log(data["cod_gasto"]);
    console.log(data["fecha_hoy"]);
    console.log(data["fecha_ticket"]);
    console.log(data["detalle"]);
    console.log(data["importe"]);
    console.log(data["categoria"]);
    console.log(data["observaciones"]);
    console.log(data["imagen"]);
    this.loading=true;
    this.http.post(`${environment.backendUrl}/api/insertadetalle/insertarpost`,
    {  
      'codgasto': data["cod_gasto"],
      'fecha_hoy': data["fecha_hoy"],
      'fecha_ticket': data["fecha_ticket"],
      'detalle': data["detalle"],
      'importe': data["importe"],
      'categoria': data["categoria"],
      'observaciones': data["observaciones"],
      'imagen': data["imagen"]
    },
    {
      responseType: 'text' 
    }
    ).subscribe(res => {
        console.log(res);
        console.log("Inserto ok el nuevo subgasto!");     
        this.loading=false;
        this.snackBar.open('SubGasto añadido correctamente!', 'Cerrar', {duration: 3000});
        this.global.historicalTo("+SUMO UN TICKET NUEVO AL GASTO COD ["+ this.codgas+"], det: *"+ this.DETALLE +"*, de fecha: " + this.FECHA_TICKET + ", catego: " + this.CATEGORIA + ", importe: $" + this.IMPORTE +", a las " + this.global.horario(),'AÑADE-SUBGASTO');
    },
      err => {
        console.log("salio por error!!!!!!");
        console.log(err);
      });

         
    /*
    console.log("INSERTA NUEVO!");
    //calcula fecha hoy
    console.log(this.fotodetalle);
    this.http.get(`${environment.backendUrl}/api/insertadetalle/detalle_insertar?codgas=${this.codgas}&fecha_hoy=${this.fecha_hoy}&fecha_ticket=${this.FECHA_TICKET}&detalle=${this.DETALLE}&importe=${this.IMPORTE}&categoria=${this.CATEGORIA}&observaciones=${this.OBSERVACIONES}`)
    .subscribe((data: any) => {
      this.result = JSON.stringify(data["affectedRows"]);
      if (this.result==1){
        
        console.log(`DETALLE NUEVO INSERTADO PARA AEL GASTO COD: ${this.codgas} ** INSERTADO ** correctamente de la bd!`);
        // snackbar si encuentra al usuario
        this.snackBar.open('Añaido correctamente!', 'Cerrar', {duration: 4000});
        this.cargaGrid();
        this.fotodetalle=null;
        this.fotob64=null;
        this.limpiacam();
        
      }else{
        this.limpiacam();
        console.log(`SURGIO UN ERROR AL INSERTAR NUEVO DETALLE..`);
        this.snackBar.open('Error al añadir el nuevo sub-gasto', 'Cerrar', {duration: 4000});
      }
    });

  */
    
  
  }


  download(){
    //return a promise that resolves with a File instance
    function urltoFile(url, filename, mimeType){
      mimeType = mimeType || (url.match(/^data:([^;]+);/)||'')[1];
      return (fetch(url)
          .then(function(res){return res.arrayBuffer();})
          .then(function(buf){return new File([buf], filename, {type:mimeType});})
      );
    }

    //Usage example:
    urltoFile(this.fotito,'ticketgasto','png')
    .then(function(file){
      console.log(file);
    })
  }

  
  snackCamara(){
    // snackbar si encuentra al usuario
    this.snackBar.open('IMAGEN LISTA!!!', 'Cerrar', {duration: 3000});
  }



  quitarImagen(){
    this.fotodetalle=null;
    this.limpiacam();
  }

  imprimirGastos(){
    console.log("enviando al local storage.. arrayGastoPrint");
    localStorage.setItem('arrayGastoPrint', JSON.stringify(this.dataSource.data));
    //console.log(JSON.parse(localStorage.getItem('arrayGastoPrint')));
    //this.router.navigate(['/print-gastos']); 
  }


  /*migra a webcam*/
  
  prendeCamara(){
    //prende ngx-webcam 4
    this.showWebcam = true;  
  }
  
  //tocar imagen
  fullscreen(){
    document.getElementById("fotocopia").requestFullscreen();
  }

  //rotar imagen a lo mand
  cont=0;
  rotate(){
    this.cont = this.cont + 90;
    var img = document.getElementById("fotocopia");
    img.style.webkitTransform = `${this.cont}deg`;
    img.style.rotate = `${this.cont}deg`;
    img.style.transform = `rotate(${this.cont}deg)`;     
  }
  

}
